import { cashAdjustmentApi } from "../../api";

const CashAdjustmentService = {

  /**
   * ⚖️ Registrar ajuste de caja
   * POST /api/cash/adjustments
   */
  adjustment: async (data: any) => {

    const response = await cashAdjustmentApi.add(data);

    return response.data;

  }

};

export default CashAdjustmentService;